import routes from '@/routers/routes';
import { fetchMeIsAuthenticated, requestAuthSessionRevalidate } from '@/utils/authMe';
import { createRouter, createWebHistory } from 'vue-router';

const router = createRouter({
  history: createWebHistory('/'),
  routes,
  scrollBehavior(to, from, savedPosition) {
    // ブラウザの戻る/進むのときは前のスクロール位置を維持
    if (savedPosition) {
      return savedPosition;
    }
    // 求人検索は同一 /jobs 内でクエリだけ変えることが多い。ルーター側でトップへ飛ばすと
    // 検索ボタン押下時の即時トップ化と競合するので位置を維持する。
    // 検索実行時は composable 側で snapWindowToTopWithBriefScrollLock を呼ぶ。
    if (to.path === '/jobs' && from.path === '/jobs') {
      return false;
    }
    return { top: 0 };
  },
});

router.beforeEach(async to => {
  if (!to.meta.requiresGuest) {
    return true;
  }
  const authenticated = await fetchMeIsAuthenticated();
  if (authenticated) {
    return { path: '/', replace: true };
  }
  return true;
});

if (typeof window !== 'undefined') {
  window.addEventListener('pageshow', (event: PageTransitionEvent) => {
    if (event.persisted) {
      requestAuthSessionRevalidate();
    }
  });
}

export default router;
